import React from 'react';

export default function ArrowIcon(props: any) {
  return (
    <span {...props}>
      <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M7.22582 15.6816L0.437077 8.89289C0.0204859 8.4763 0.0204859 7.80087 0.437077 7.38428L7.22582 0.595535C7.64241 0.178945 8.31784 0.178945 8.73443 0.595535C9.15102 1.01213 9.15102 1.68756 8.73443 2.10415L3.76674 7.07184L2.79376 8.23214L8.73443 14.173C9.15102 14.5896 9.15102 15.265 8.73443 15.6816C8.31784 16.0982 7.64241 16.0982 7.22582 15.6816Z" fill="#A5A5A5" />
      </svg>
    </span>
  );
}